<template>
  <div
    class="
      el-table
      flex-grow-1
      d-flex
      flex-column
      el-table--fit
      el-table--striped
      el-table--scrollable-y
      el-table--enable-row-hover
      el-table--small
    "
    :class="{dark: skinType}"
    style="width: 100%; height: 0px"
  >
    <div class="hidden-columns">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="el-table__header-wrapper">
      <table
        cellspacing="0"
        cellpadding="0"
        border="0"
        class="el-table__header"
        style="width: 1077px"
      >
        <colgroup>
          <col name="el-table_39_column_377" width="60" />
          <col name="el-table_39_column_378" width="128" />
          <col name="el-table_39_column_379" width="127" />
          <col name="el-table_39_column_380" width="127" />
          <col name="el-table_39_column_381" width="127" />
          <col name="el-table_39_column_382" width="127" />
          <col name="el-table_39_column_383" width="127" />
          <col name="el-table_39_column_384" width="127" />
          <col name="el-table_39_column_385" width="127" />
          <col name="gutter" width="16" />
        </colgroup>
        <thead class="has-gutter">
          <tr class="">
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_377 is-leaf header-text"
            >
              <div class="cell">#</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_378 is-leaf header-text"
            >
              <div class="cell">名称</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_379 is-leaf header-text"
            >
              <div class="cell">供电类型</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_380 is-leaf header-text"
            >
              <div class="cell">所属柜号</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_381 is-leaf header-text"
            >
              <div class="cell">起码(kWh)</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_382 is-leaf header-text"
            >
              <div class="cell">起码时间</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_383 is-leaf header-text"
            >
              <div class="cell">止码(kWh)</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_384 is-leaf header-text"
            >
              <div class="cell">止码时间</div>
            </th>
            <th
              colspan="1"
              rowspan="1"
              class="el-table_39_column_385 is-leaf header-text"
            >
              <div class="cell">用电量(kWh)</div>
            </th>
            <th class="gutter" style="width: 16px"></th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="el-table__body-wrapper is-scrolling-none" style="height: 605px">
      <table
        cellspacing="0"
        cellpadding="0"
        border="0"
        class="el-table__body"
      >
        <colgroup>
          <col name="el-table_39_column_377" width="60" />
          <col name="el-table_39_column_378" width="128" />
          <col name="el-table_39_column_379" width="127" />
          <col name="el-table_39_column_380" width="127" />
          <col name="el-table_39_column_381" width="127" />
          <col name="el-table_39_column_382" width="127" />
          <col name="el-table_39_column_383" width="127" />
          <col name="el-table_39_column_384" width="127" />
          <col name="el-table_39_column_385" width="127" />
        </colgroup>
        <tbody>
          <tr
            class="el-table__row"
            v-for="(rowItem, index) of tableData.list"
            :key="index"
            :class="[{'el-table__row--striped':index%2===0},{
               'dark text-white' : skinType
            }]"
          >
            <td rowspan="1" colspan="1" class="el-table_39_column_377">
              <div class="cell"><div>1</div></div>
            </td>
            <td
              rowspan="1"
              colspan="1"
              class=""
              v-for="(header, index) of tableData.headers"
              :key="index"
            >
              <div class="cell">{{ rowItem[header.prop] }}</div>
            </td>
          </tr>
          <!---->
        </tbody>
      </table>
      <!----><!---->
    </div>
    <!----><!----><!----><!---->
    <div class="el-table__column-resize-proxy" style="display: none"></div>
  </div>
</template>
<script>
export default {
  name: 'native-el-table',
  props: {
    tableData: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  data() {
    return {};
  },
};
</script>
